const siteFooter = document.querySelector('.site-footer');
const graphic1 = document.querySelector('.footer-graphic-1');
const graphic2 = document.querySelector('.footer-graphic-2');

if (siteFooter && graphic1 && graphic2) {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!prefersReducedMotion) {
        graphic1.style.opacity = '0';
        graphic2.style.opacity = '0';
    }

    function startDropAnimation() {
        // Skip while the contact overlay is open — contact-takeover.js manages that
        if (siteFooter.classList.contains('is-open')) return;
        graphic1.classList.remove('is-floating');
        graphic2.classList.remove('is-floating');
        void graphic1.offsetWidth; // force reflow to restart animation
        graphic1.classList.add('is-floating');
        graphic2.classList.add('is-floating');
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) startDropAnimation();
        });
    }, { threshold: 0.1, rootMargin: '0px 0px -20% 0px' });

    observer.observe(siteFooter);
}
